<template>
  <div>
      <food-menu-sidebar
      :isSidebarActive="FoodViewSidebar"
      @closeSidebar="closeSidebar"
    />
      <setting-menu-sidebar
      :isSidebarActive="SettingViewSidebar"
       @closeSettingSidebar="closeSettingSidebar"
      />
  <vs-card >
      
    <div slot="header">
      <h5>Menu Option</h5>
    </div>      
    <div>
  <vs-row >
 <vs-col  vs-type="flex" vs-justify="center" vs-w="5">
 <vs-card >
    <div class="flex  justify-between">
       <h6 class="text-primary">Available</h6>
        <span @click="addItem()" class="cursor-pointer"> <feather-icon icon="PlusIcon"  svgClasses="w-5 h-5 hover:text-primary stroke-current"/></span>
    </div>   
    <div>
    <vs-list>
    <draggable :list="available_items" group="people" class="p-2 cursor-move">
    <vs-list-item :title="available_item.name"  v-for="(available_item,item) in available_items" :key="available_item.id">
    <vx-tooltip text="Edit" style="float: left">
    <feather-icon icon="EditIcon" class="ml-1" svgClasses="w-4 h-4 hover:text-primary stroke-current cursor-pointer"  @click="editItem(item)" />
    </vx-tooltip>
    <vx-tooltip text="Delete" style="float: left">
    <feather-icon icon="TrashIcon" class="ml-1" svgClasses="w-4 h-4 hover:text-danger stroke-current cursor-pointer"  @click="deleteItem(item)"/>
    </vx-tooltip>
    </vs-list-item>
    
    </draggable>
    </vs-list>
    </div>   
  </vs-card>
 </vs-col>
   <vs-col vs-offset="1" vs-type="flex" vs-justify="center" vs-w="5">
    <vs-card >
    <div >
       <h6 class="text-success">Active</h6>
    </div> 
    <div>
    <vs-list>
    <draggable :list="active_items" group="people" class="p-2 cursor-move">
    <vs-list-item :title="active_item.name"  v-for="active_item in active_items" :key="active_item.id"></vs-list-item>
      </draggable>
    </vs-list>
    </div>     
  </vs-card>
  </vs-col>
</vs-row>
    </div>
  </vs-card>
<vx-card title="View Menu">
  <vs-row class="mb-base">
  <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6">
    <vs-select
    v-on:input="selectWeek"
    class=""
    placeholder="Select Week"
    autocomplete
    v-model="setWeek">
    <vs-select-item :key="index" :value="week.id" :text="week.week" v-for="week,index in weeks" />
  </vs-select>
  </vs-col>
   <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
   <vs-button size="small" @click="setCurrentWeek()">Current Week</vs-button>
   <vs-button size="small" class="ml-2" @click="addWeek">Add Week</vs-button>
   <vs-button size="small" class="ml-2" color="danger" @click="deleteWeek()">Delete Week</vs-button>
   <feather-icon icon="SettingsIcon" class="ml-1" @click="toggleSettingSidebar(true)" svgClasses="w-5 h-5 hover:text-primary stroke-current cursor-pointer"  />

   <!-- <vs-button @click.native="toggleFoodSidebar(true)"></vs-button> -->
  </vs-col>
</vs-row>
    <div v-for="item in active_items" :key="item.id" class="mb-base">
       <vs-card  :title="'Week '+setWeek+' '+item" v-if="setWeek">
         <div slot="header">
           <small class="font-bold">{{'Week '+getWeekName()+' - '+item.name}}</small>
        </div> 
<vs-row
  vs-align="flex-end"
  vs-type="flex" vs-justify="space-around" vs-w="12">
    <vs-col :key="index" v-for="(day,index) in item.days" vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
      <div>
       <small class="font-bold">{{day.day}}</small><br>
       <vs-textarea width="120px" v-model="day.value"></vs-textarea>
      </div>

    </vs-col>
</vs-row>
       </vs-card>
    </div>
     <div>
        <vs-row vs-justify="flex-end">
          <vs-button @click="saveItems"> Save </vs-button>
       </vs-row>
      </div>
</vx-card>
                














<div class="centerx con-exemple-prompt">
     <vs-prompt
      @cancel="addMenu=false"
      @accept="addNewItem"
      @close="addMenu=false"
      accept-text="Save"
      title="Add New Menu"	
      :active.sync="addMenu">
       <div class="con-exemple-prompt">
           <vs-input class="w-full" label-placeholder="Name" v-model="newItemName"></vs-input>
       </div>
     </vs-prompt>
      <vs-prompt
      @cancel="editMenu=false"
      @accept="EditItem"
      @close="editMenu=false"
      accept-text="Save"
      title="Add New Menu"	
      :active.sync="editMenu">
       <div class="con-exemple-prompt">
           <vs-input class="w-full" label-placeholder="Name" v-model="editItemName"></vs-input>
       </div>
     </vs-prompt>
  </div>
   
  </div>
</template>
<script>
import FoodMenuSidebar from './FoodMenuSidebar.vue'
import SettingMenuSidebar from './SettingMenuSidebar.vue'

import {
  GET_ALL_MENU_OPTION,
  ADD_NEW_MENU_WEEK,
  GET_ALL_MENU_WEEKS,
  ADD_WEEK_MENU_ITEMS,
  ADD_NEW_MENU_OPTION,
  DELETE_MENU_WEEK,
  GET_WEEK_DATA ,
  SET_CURRENT_WEEK
} from '@/graphql'
import draggable from 'vuedraggable'
export default {
  components: {
    draggable,
    FoodMenuSidebar,
    SettingMenuSidebar
  },
    data() {
    return {
      days:[
          {
              'day':'Monday',
              'value':'',
          },
          {
              'day':'Tuesday',
              'value':'',
          },
          {
              'day':'Wednesday',
              'value':'',
          },
          {
              'day':'Thrusday',
              'value':'',
          },
          {
              'day':'Friday',
              'value':'',
          },
          {
              'day':'Saturday',
              'value':'',
          },
          {
              'day':'Sunday',
              'value':'',
          }
        ],
      available_items:[
        {
        'id':5,
        'name':'Dinner',
        'days':[
          {
              'day':'Monday',
              'value':'',
          },
          {
              'day':'Tuesday',
              'value':'',
          },
          {
              'day':'Wednesday',
              'value':'',
          },
          {
              'day':'Thrusday',
              'value':'',
          },
          {
              'day':'Friday',
              'value':'',
          },
          {
              'day':'Saturday',
              'value':'',
          },
          {
              'day':'Sunday',
              'value':'',
          }
        ],
        }
        ],
      active_items:[
        {
        'id':1,   
        'name':'Breakfast',
        'days':[
          {
              'day':'Monday',
              'value':'',
          },
          {
              'day':'Tuesday',
              'value':'',
          },
          {
              'day':'Wednesday',
              'value':'',
          },
          {
              'day':'Thrusday',
              'value':'',
          },
          {
              'day':'Friday',
              'value':'',
          },
          {
              'day':'Saturday',
              'value':'',
          },
          {
              'day':'Sunday',
              'value':'',
          }
        ]
         },
        {
        'id':2, 
        'name':'AM Snack',
        'days':[
          {
              'day':'Monday',
              'value':'',
          },
          {
              'day':'Tuesday',
              'value':'',
          },
          {
              'day':'Wednesday',
              'value':'',
          },
          {
              'day':'Thrusday',
              'value':'',
          },
          {
              'day':'Friday',
              'value':'',
          },
          {
              'day':'Saturday',
              'value':'',
          },
          {
              'day':'Sunday',
              'value':'',
          }
        ]
        },
        {
        'id':3, 
        'name':'Lunch',
        'days':[
          {
              'day':'Monday',
              'value':'',
          },
          {
              'day':'Tuesday',
              'value':'',
          },
          {
              'day':'Wednesday',
              'value':'',
          },
          {
              'day':'Thrusday',
              'value':'',
          },
          {
              'day':'Friday',
              'value':'',
          },
          {
              'day':'Saturday',
              'value':'',
          },
          {
              'day':'Sunday',
              'value':'',
          }
        ]
        },
        {
        'id':4,
        'name':'PM Snack',
        'days':[
          {
              'day':'Monday',
              'value':'',
          },
          {
              'day':'Tuesday',
              'value':'',
          },
          {
              'day':'Wednesday',
              'value':'',
          },
          {
              'day':'Thrusday',
              'value':'',
          },
          {
              'day':'Friday',
              'value':'',
          },
          {
              'day':'Saturday',
              'value':'',
          },
          {
              'day':'Sunday',
              'value':'',
          }
        ]
        }
        ],
          addMenu:false,
          editMenu:false,
          newItemName:'',
          editItemName:'',
          currentItem:null,
          weeks:[],
          setWeek:null,
          FoodViewSidebar: false,
          SettingViewSidebar:false,
         
    };
  },
  watch:{
     addMenu(val){
        this.newItemName=''
     },
    setWeek(val){
        this.getWeekData(val)
    },
  },
  methods:{
    toggleSettingSidebar(val = false) {
      this.SettingViewSidebar = val;
    },
    closeSettingSidebar(){
         this.SettingViewSidebar = false;
    },
    closeSidebar(){
         this.FoodViewSidebar = false;
    },
    toggleFoodSidebar(val = false) {
      this.FoodViewSidebar = val;
    }, 
    getWeekName(){
      for (let index = 0; index < this.weeks.length; index++) {
       if(this.weeks[index].id == this.setWeek){
         return this.weeks[index].name
       }
        
      }
    },
    setCurrentWeek(){
      this.$apollo
        .mutate({
          mutation: SET_CURRENT_WEEK,
          variables: {
            week:this.setWeek,
            site:this.$route.params.siteName
          }
        })
        .then(response => {
          if (response) {
           if(response.data.setCurrentWeek.status==='Success'){

            }
          }
        }).catch(error => {
          console.log(error)
        })

    },
    getWeekData(val){
      if(val){
         this.$apollo
        .mutate({
          mutation: GET_WEEK_DATA,
          variables: {
            week:val
          }
        })
        .then(response => {
          if (response) {
              if(response.data.getWeekData.status==='Success'){
                this.active_items=JSON.parse(response.data.getWeekData.data);
              }
              else{
                  this.active_items.forEach(element => {
                   element.days=[
                    {
                        'day':'Monday',
                        'value':'',
                    },
                    {
                        'day':'Tuesday',
                        'value':'',
                    },
                    {
                        'day':'Wednesday',
                        'value':'',
                    },
                    {
                        'day':'Thrusday',
                        'value':'',
                    },
                    {
                        'day':'Friday',
                        'value':'',
                    },
                    {
                        'day':'Saturday',
                        'value':'',
                    },
                    {
                        'day':'Sunday',
                        'value':'',
                    }
                  ]
                });
              }
          }
        }).catch(error => {
          console.log(error)
        })
      }
    },
    selectWeek(event){
      console.log(event)
    },
    deleteWeek(){
      if(this.weeks.length>1){
        this.$apollo
        .mutate({
          mutation: DELETE_MENU_WEEK,
          variables: {
            week:this.setWeek
          }
        })
        .then(response => {
          if (response) {
           if(response.data.deleteMenuWeek.status==='Success'){
                this.getAllWeeks()
            }
          }
        }).catch(error => {
          console.log(error)
        })
      }
    },
    saveItems(){
         if(this.setWeek){
         var sendItem = JSON.stringify(this.active_items)
         console.log(sendItem,this.setWeek)
        this.$apollo
        .mutate({
          mutation: ADD_WEEK_MENU_ITEMS,
          variables: {
            data:sendItem,
            week:this.setWeek
          }
        })
        .then(response => {
          if (response) {
           if(response.data.addWeekMenuItems.status==='Success'){
               this.StatusSuccess()
            }
          }
        }).catch(error => {
          console.log(error)
        })
         }
    },
    getAllMenuOptions(){
      this.$apollo
        .mutate({
          mutation: GET_ALL_MENU_OPTION,
          variables: {
            site: this.$route.params.siteName,
          },
        })
        .then((response) => {
          let data = response.data.getAllMenuOption
          let active = []
          let available = [] 
          this.available_items=this.active_items=[]
          data.forEach(element => {
          element['days'] = this.days
          if(element.status){
             active.push(element)
          }
          else{
            available.push(element)
          }
          });
          this.available_items=available
          this.active_items=active
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getAllWeeks(){
     this.$apollo
        .mutate({
          mutation: GET_ALL_MENU_WEEKS,
          variables: {
            site: this.$route.params.siteName,
          },
        })
        .then((response) => {
          let data = response.data.getAllMenuWeeks
          if(data.length>0){
          this.weeks =[]
          data.forEach(element => {
           element['week'] = 'Week '+element.name
         });
         this.weeks = data
         this.setWeek =  this.weeks[this.weeks.length - 1].id
         }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addWeek(){
      //  let curr = new Date 
      //   let week = []

      //   for (let i = 1; i <= 7; i++) {
      //     let first = curr.getDate() - curr.getDay() + i 
      //     let day = new Date(curr.setDate(first)).toISOString().slice(0, 10)
      //     week.push(day)
      //   }
      //   console.log(week)
      
       this.$apollo
        .mutate({
          mutation: ADD_NEW_MENU_WEEK,
          variables: {
            data:this.$route.params.siteName
          }
        })
        .then(response => {
          if (response) {
           if(response.data.addNewMenuWeek.status==='Success'){
              this.getAllWeeks();
            }
          }
        }).catch(error => {
          console.log(error)
        })

    },
    addNewItem(){
      var new_item = {
        'name':this.newItemName,
        'days':[
          {
              'day':'Monday',
              'value':'',
          },
          {
              'day':'Tuesday',
              'value':'',
          },
          {
              'day':'Wednesday',
              'value':'',
          },
          {
              'day':'Thrusday',
              'value':'',
          },
          {
              'day':'Friday',
              'value':'',
          },
          {
              'day':'Saturday',
              'value':'',
          },
          {
              'day':'Sunday',
              'value':'',
          }
        ]
    }
      this.$apollo
        .mutate({
          mutation: ADD_NEW_MENU_OPTION,
          variables: {
            site:this.$route.params.siteName,
            item:this.newItemName
          }
        })
        .then(response => {
          if (response) {
           if(response.data.addNewMenuOption.status==='Success'){
              this.available_items.push(new_item)
              // this.getAllMenuOptions()
            }
          }
        }).catch(error => {
          console.log(error)
        })


    },
    EditItem(){
      this.available_items[this.currentItem].name = this.editItemName
    },
    editItem(item){
     this.currentItem=item
     this.editItemName=this.available_items[item].name
     this.editMenu=true
    },
    addItem(){
         this.addMenu=true
    },
    deleteItem(item){
      this.available_items.splice(item, 1);
    },
    StatusSuccess () {
      this.$vs.notify({
        title: 'Menu',
        text: 'Saved successfully',
        color: 'success',
        position: 'top-right'
      })
    },
  },
  created(){
      this.getAllWeeks()
      // this.getAllMenuOptions()
      console.log(this.$route.params.siteName)
  },
 updated(){
    
 },
}
</script>


